import React, { useEffect, useCallback, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "@dreamchimney/react-axios";
import ReactTags from "react-tag-autocomplete";
import { useHistory } from "react-router-dom";
import styles from "../../css/reactTags.less";
import ApiEndpoints from "../../api/apiConfig";

import PropTypes from "prop-types";
//import { Test } from './AddStep2.styles';

// tags: Array(5)
// 0: "Rad Dude"
// 1: "Chest Hair"
// 2: "Stache"
// 3: "Pose"
// 4: "Cassette"

// const tags = [
//   { id: 1, name: "Apples" },
//   { id: 2, name: "Pears" },
// ];

const tagsToSuggestions = (tags) =>
  (Array.isArray(tags) &&
    tags.map((t, i) => {
      return { id: i, name: t };
    })) ||
  [];

const AddStep2 = ({ sleeve: sleeveStep1, handleSubmit, handleCancel, edit = false }) => {
  let history = useHistory();

  const [tags, setTags] = useState(tagsToSuggestions(sleeveStep1.tags) || []);
  const [suggestions, setSuggestions] = useState([]);
  const reactTags = useRef();

  const [validating, setValidating] = useState(false);
  const [sleeve, setSleeve] = useState({
    ...sleeveStep1,
    img_upload: sleeveStep1?.img_upload || null,
    ext_url: sleeveStep1?.ext_url || "",
  });
  // const [sleeve, setSleeve] = useState({});
  const imageUrl = sleeveStep1?.img_upload_url || sleeveStep1?.ext_url || null;

  const handleTitle = (event) => {
    setSleeve({ ...sleeve, ...{ title: event.target.value } });
  };
  const handleArtist = (event) => {
    setSleeve({ ...sleeve, ...{ artist: event.target.value } });
  };

  // useEffect(() => {
  //   console.log("🚀 ~ file: AddStep2.js ~ line 22 ~ useEffect ~ sleeve", sleeve);
  // }, [sleeve]);

  // final `tags` should be array(0 => array('text' => 'tag), 1 => array('text' => 'tag 2))
  const handleTagInput = async (event) => {
    {
      const {
        data: { tags = [] },
      } = await axios.get(`${ApiEndpoints.sleevesTags}?q=${event}`);
      // const tagsToSuggestions =
      //   tags.map((t, i) => {
      //     return { id: i, name: t };
      //   }) || [];
      setSuggestions(tagsToSuggestions(tags));
    }
  };

  const onCancel = () => {
    handleCancel();
  };

  const handleAddSleeve = () => {
    // validation
    setValidating(true);
    const tagsToDb = tags.map((s, i) => {
      const t = {};
      t.text = s.name;
      return t;
    });
    const payload = {
      ...sleeve,
      tags: tagsToDb,
    };
    handleSubmit(payload).then(() => {
      console.log("🚀 ~ file: AddStep2.js:89 ~ handleSubmit ~ payload:", payload);
      setValidating(false);
      const route = payload.id ? `/sleeves/view/${payload.id}` : `/`;
      history.push(route);
    });
  };

  const onDelete = useCallback(
    (tagIndex) => {
      setTags(tags.filter((_, i) => i !== tagIndex));
    },
    [tags]
  );

  const onAddition = useCallback(
    (newTag) => {
      setTags([...tags, newTag]);
    },
    [tags]
  );

  return (
    <div className="page-edit">
      <div className="row" ng-show="step2">
        <div className="col-xs-12 col-sm-6 col-md-4">
          {!imageUrl ? (
            <img src={`https://res.cloudinary.com/dreamchimney/image/upload/w_450/sleevery/${sleeve.id}.jpg`} className="img-responsive" />
          ) : (
            <img src={imageUrl} className="img-responsive" />
          )}

          {/* <div className="otd-img otd-img-upload">
          <span className="img_upload" ng-show="sleeve.img_upload_preview">
            <img img-fix-orientation="sleeve.img_upload_preview" src={imageUrl} className="img-responsive" />
          </span>
        </div> */}
        </div>
        <div className="col-xs-12 col-sm-6 col-md-8">
          <div className="form-group">
            <label className="col-md-3 control-label" htmlFor="title">
              Album Title:
            </label>
            <div className="col-md-8">
              <input
                id="title"
                name="title"
                type="text"
                placeholder=""
                className="form-control input-md"
                required
                value={sleeve.title}
                onChange={handleTitle}
                style={validating && !sleeve.title ? { border: `1px solid red` } : null}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="col-md-3 control-label" htmlFor="artist">
              Artist:
            </label>
            <div className="col-md-8">
              <input
                id="artist"
                name="artist"
                type="text"
                placeholder=""
                className="form-control input-md"
                required
                value={sleeve.artist}
                onChange={handleArtist}
                style={validating && !sleeve.artist ? { border: `1px solid red` } : null}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="col-md-3 control-label" htmlFor="tags">
              Tags:
            </label>
            <div className={`col-md-12 ${validating && tags.length === 0 ? `add-tags-error` : null}`}>
              <ReactTags
                allowNew
                onInput={handleTagInput}
                ref={reactTags}
                tags={tags}
                suggestions={suggestions}
                onDelete={onDelete}
                onAddition={onAddition}
              />

              <span className="help-block">
                <p className="notes">Tag Help</p>
                <ul>
                  <li>Use autocomplete to help find existing tags.</li>
                  <li>To add a new tag hit tab/enter at the end of the text.</li>
                </ul>
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="col-md-3 control-label" htmlFor=""></label>
            <div className="col-md-8">
              {validating && <div className="loading">{edit ? `Updating` : `Uploading`} your sleeve, please hold...</div>}

              <button type="button" disabled={validating} onClick={handleAddSleeve} className="btn btn-primary">
                {edit ? `Save` : `Add`} Sleeve
              </button>

              <a onClick={onCancel} href="#" className="btn btn-default btn-cancel">
                Cancel
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AddStep2.propTypes = {
  // bla: PropTypes.string,
};

AddStep2.defaultProps = {
  // bla: 'test',
};

export default AddStep2;
